import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as actions from '@redux/actions';
import { AppState } from '@redux/app.reducers';
import { map } from 'rxjs/operators';

@Injectable()
export class RecommendedProductsEffects {
  constructor(private actions$: Actions, private store: Store<AppState>) {}

  /**
   * Ensure life plan insurance targets are updated every time product recommendations
   * are obtained.
   */
  updateInsuranceTargetsWithRecommendations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateProductsPerInsuranceTarget),
      map(params =>
        actions.updateLifePlanInsuranceTargetsWithRecommendations({
          productsPerInsuranceTarget: params.newProductsPerInsuranceTarget
        })
      )
    )
  );
}
